import NumberInput from '../../../common/components/Form/NumberInput.js'
import {
  updateParcel,
  declaredValueSelector,
  declaredValueWarningSelector,
  declaredValueErrorSelector,
  isMultiboxSelector,
  isLabelPropertyEnabledSelector,
  VALID_DECLARED_VALUE_SHIPPER_TYPES,
} from '../../../data/labelInfos/index.js'
import {showMultiboxModal} from '../../LabelConfig/Modals/MultiboxModal/index.js'
import {useSelector} from '../../../store.js'
import useLabelProperty, {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
  formatMetaClassName,
} from './useLabelProperty.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import className from '../../../common/className.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

export function formatDeclaredValueProperty(shipperType) {
  return `${shipperType}__declared_value`
}
function labelPropertiesFunc(shipperType) {
  return VALID_DECLARED_VALUE_SHIPPER_TYPES.includes(shipperType)
    ? [`packages[0].${formatDeclaredValueProperty(shipperType)}`]
    : []
}

export default function DeclaredValue({packagesIndex}) {
  packagesIndex = packagesIndex || 0

  const {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    isSummary,
    isPickMode,
  } = useLabelConfigContext()
  const propertySpecs = DeclaredValue.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const declaredValue = useSelector((state) =>
    declaredValueSelector(state, {labelInfoID, shipperType, packagesIndex}),
  )
  const warning = useSelector((state) =>
    declaredValueWarningSelector(state, {labelInfoID, shipperType}),
  )
  const error = useSelector((state) =>
    declaredValueErrorSelector(state, {labelInfoID, shipperType}),
  )
  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID, shipperType}),
  )

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  const disabled = isMultibox || (isLabelEnableMode && !isLabelPropertyEnabled)

  if (!propertySpecs.validShipperTypes.includes(shipperType)) {
    return null
  }

  const label = 'Declared Value'

  if (isSummary) {
    return label
  }

  if (isPickMode) {
    return <PickLabelProperty label={label} labelProperty={labelProperty} />
  }

  return (
    <li
      className={className`list__item--shipping-options btm-offset-7 ${formatMetaClassName(
        labelProperty,
      )} ${{
        'property-disabled': disabled,
      }}`}
    >
      <div className="wrap--edit-preset-form-input">
        <div className="flex">
          <label
            className="label--bold label--config__txt"
            htmlFor="declared_value"
          >
            {label}
          </label>
          {isMultibox && (
            <button
              className="btn btn--link margin-bottom-3 margin-left-3 fs-n0"
              type="button"
              onClick={() => showMultiboxModal(labelInfoID, shipperType)}
            >
              <em>(Multiple)</em>
            </button>
          )}
        </div>
        <NumberInput
          type="text"
          id={`${labelInfoID}__${labelProperty}`}
          value={isMultibox ? '' : declaredValue}
          disabled={disabled}
          onChange={(value) => {
            updateParcel(labelInfoID, packagesIndex, {
              [formatDeclaredValueProperty(shipperType)]: value,
            })

            onChange()
          }}
        />
        {warning && <small className="warning">{warning}</small>}
        {error && <small className="error">{error}</small>}
      </div>
      <EnableLabelProperty labelProperty={labelProperty} />
    </li>
  )
}

DeclaredValue.propertySpecList = [
  {
    validShipperTypes: VALID_DECLARED_VALUE_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
